import './App.css';
import Home from './components/Home';

function App() {
  return (
    <div className='bg-blue-400 h-screen flex items-center justify-center'>
      <Home />
    </div>
  );
}

export default App;
